import { LOCATION } from './location';

export const EVENT_TEMPLATE_TYPE = 'EVENT';

export const USER_TEMPLATE_TYPE = 'USER';

export const RETENTION_TEMPLATE_TYPE = 'RETENTION';

export const REVENUE_TEMPLATE_TYPE = 'REVENUE';

export const unitsTypes = {
  EVENTS_TYPE: 'EVENTS',
  USERS_TYPE: 'USERS',
  RETENTION_TYPE: 'RETENTION',
  RETENTION_COMPLEX_TYPE: 'RETENTION COMPLEX',
  REVENUE_TYPE: 'REVENUE',
  FUNNELS_TYPE: 'FUNNELS',
};

export const typeToKey = {
  [unitsTypes.EVENTS_TYPE]: 'events',
  [unitsTypes.USERS_TYPE]: 'users',
  [unitsTypes.RETENTION_TYPE]: 'retention',
  [unitsTypes.RETENTION_COMPLEX_TYPE]: 'retentionComplex',
  [unitsTypes.REVENUE_TYPE]: 'revenue',
  [unitsTypes.FUNNELS_TYPE]: 'funnels',
};

export const typesToTemplates = {
  [EVENT_TEMPLATE_TYPE]: unitsTypes.EVENTS_TYPE,
  [USER_TEMPLATE_TYPE]: unitsTypes.USERS_TYPE,
  [RETENTION_TEMPLATE_TYPE]: unitsTypes.RETENTION_COMPLEX_TYPE,
  [REVENUE_TEMPLATE_TYPE]: unitsTypes.REVENUE_TYPE,
};

export const TEMPLATE_TYPE = {
  [EVENT_TEMPLATE_TYPE]: 'Events',
  [USER_TEMPLATE_TYPE]: 'Users',
  [RETENTION_TEMPLATE_TYPE]: 'Retention',
};

export const TEMPLATE_AGGREGATION_TYPE = {
  COUNT: 'count',
  USERS: 'uniq',
  TOTAL: 'sum',
  AVERAGE_COUNT: 'avg_count',
  AVERAGE_TOTAL: 'avg_total',
  AVERAGE_COUNT_SPLIT: 'avg_count_split',
  AVERAGE_TOTAL_SPLIT: 'avg_total_split',
};

export const LOCATION_BY_TYPE = {
  [EVENT_TEMPLATE_TYPE]: LOCATION.EVENTS,
  [USER_TEMPLATE_TYPE]: LOCATION.USERS,
  [RETENTION_TEMPLATE_TYPE]: LOCATION.ADVANCED_RETENTION,
};

export const UNATTACHED_DASHBOARD_ID = 'UnattachedTemplates';
